import axios from 'axios'
import qs from 'qs'
import pubFunction from '../public/index.js'
import {
	Notification
} from 'element-ui'
import store from '../store/index.js'

// const requestUrl = 'http://114.116.226.211:8803/api/'
const requestUrl = pubFunction.requestUrl

// 需要token验证的接口
const tokenApi = [
	'findAppraiserList',
	'findAppraiserById',
	'addOrUpdateAppraiser',
	'deleteAppraiser',
	'exportAppraiser',
	'findCaseInformationList',
	'findCaseInformationById',
	'checkIdentified',
	'addOrUpdateCaseInformation',
	'submitOpinion',
	'deleteCaseInformation',
	'exportCaseInfo',
	'exportCaseInfoGov',
	'exportCaseInfoInput',
	'getEntrustWord',
	'getAlTotalCase',
	'findOrganizationList',
	'findOrganizationById',
	'addOrUpdateOrganization',
	'deleteOrganization',
	'exportOrgan',
	'authenReal',
	'statistics',
	'entrustedAgencystatistics',
	'statisticsByOrganType',
	'statisticsByCity',
	'findSystemDictonaryList',
	'changePassword',
	'passCaseInfoAuditDetail',
	'changeCaseInfoAudit',
	'getAppraisalType',
	'updateAppraisalType',
	'findAppraiserByOrganNo'
]
// 非必须token验证的接口
const loginApi = [

]
const uploadApi = [
	'upload/upload'
]
// 本地token验证
const doRequest = (api, data, type, callback) => {
	let token = pubFunction.getStorage('o_token')
	// 必需token验证
	if (tokenApi.indexOf(api) >= 0) {
		if (!token) {
			disposeNologin()
			return false
		} else {
			axios.defaults.headers.common["X-Token"] = token
		}
	}
	// 非必须token验证
	if (loginApi.indexOf(api) >= 0) {
		axios.defaults.headers.common["X-Token"] = token
	}
	let url = requestUrl + api
	if (uploadApi.indexOf(api) >= 0) {
		axios.defaults.headers.common["X-Token"] = token
		doUpload(url, data, callback)
		return
	}
	sendPost(url, data, type, callback)
}
// 统一处理登录失效方法
const disposeNologin = () => {
	resetHeader()
	Notification.error({
		title: '发生错误',
		message: '当前登录状态已失效，请您重新登录。',
		duration: 2000,
		onClose: () => {
			store.commit('logout')
		}
	})
}
// 处理错误
const disposeError = (msg) => {
	Notification.error({
		title: '发生错误',
		message: msg,
		duration: 2000
	})
}
const resetHeader = () => {
	delete axios.defaults.headers.common['X-Token']
}
// 统一请求方法
const sendPost = (url, data, type, callback) => {
	if (type == 'GET') {
		axios.get(url, {
			params: data
		}, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then((res) => {
			if (res.data.code == 203) {
				disposeNologin()
				return
			} else if (res.data.code != 200) {
				disposeError(res.data.msg)
			}
			callback(res.data)
		}).catch((err) => {
			disposeError('发生了未知错误，请修改数据后尝试重新提交')
			callback()
		})
	} else {
		data = qs.stringify(data)
		axios.post(url, data, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then((res) => {
			if (res.data.code == 203) {
				disposeNologin()
				return
			} else if (res.data.code != 200) {
				disposeError(res.data.msg)
			}
			callback(res.data)
		}).catch((err) => {
			disposeError('发生了未知错误，请修改数据后尝试重新提交')
			callback()
		})
	}
}
const doUpload = (url, data, callback) => {
	axios.post(url, data, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	}).then((res) => {
		if (res.data.code == 203) {
			disposeNologin()
			return
		} else if (res.data.code != 200) {
			disposeError(res.data.msg)
		}
		callback(res.data)
	}).catch((err) => {
		disposeError('发生了未知错误，请修改数据后尝试重新提交')
		callback()
	})
}


//登录方法
const login = (data, callback) => doRequest('login', data, 'POST', callback)

const findCaseInformationList = (data, callback) => doRequest('findCaseInformationList', data, 'POST', callback)


const findSystemDictonaryList = (data, callback) => doRequest('findSystemDictonaryList', data, 'GET', callback)

const getCaseStatusByOrganNo = (data, callback) => doRequest('getCaseStatusByOrganNo', data, 'GET', callback)

const findCaseInformationById = (data, callback) => doRequest('findCaseInformationById', data, 'GET', callback)

const getEntrustWord = (data, callback) => doRequest('getEntrustWord', data, 'GET', callback)

const exportCaseInfo = (data, callback) => doRequest('exportCaseInfo', data, 'GET', callback)
// 修改密码
const changePassword = (data, callback) => doRequest('changePassword', data, 'GET', callback)

// 变更委托书详情
const changeCaseDetail = (data, callback) => doRequest('passCaseInfoAuditDetail', data, 'GET', callback)
// 保存审核结果
const saveAuditResult = (data, callback) => doRequest('changeCaseInfoAudit', data, 'POST', callback)
// 获取机构下鉴定类型
const getCaseMatter = (data, callback) => doRequest('getAppraisalType', data, 'GET', callback)
// 更新鉴定事项
const updateCaseMatter = (data, callback) => doRequest('updateAppraisalType', data, 'POST', callback)
// 获取鉴定人列表
const getProfessorList = (data, callback) => doRequest('findAppraiserByOrganNo', data, 'GET', callback)
// 确认终止
const confirmStop = (data, callback) => doRequest('stopCaseInformation', data, 'POST', callback)

export default {
	login,
	findCaseInformationList,
	findSystemDictonaryList,
	getCaseStatusByOrganNo,
	findCaseInformationById,
	getEntrustWord,
	exportCaseInfo,
	resetHeader,
	changePassword,
	changeCaseDetail,
	saveAuditResult,
	getCaseMatter,
	updateCaseMatter,
	getProfessorList,
	confirmStop
}
